import { render } from "./TransitionExpandTwo.vue?vue&type=template&id=1d1a97de&scoped=true&ts=true"
import script from "./TransitionExpandTwo.vue?vue&type=script&lang=ts"
export * from "./TransitionExpandTwo.vue?vue&type=script&lang=ts"

import "./TransitionExpandTwo.vue?vue&type=style&index=0&id=1d1a97de&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1a97de"]])

export default __exports__